<template>
    <div class="col-sm-12 d-flex justify-content-end">
        <div class="row">
            <button class="btn ml-4 bg-dark" @click="openLocationManager">Manage locations</button>
            <button class="btn ml-3" @click="addRoute(routeType)" :disabled="routeType == 3">+ New List</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    data: function() {
        return {

        }
    },
    props:{
        routes:{
            type: Array
        },
        routeType:{
            type: Number
        }
    },
    methods: {
        ...mapActions([
            'openModal',
        ]),
        openLocationManager: function() {
            this.openModal('TransportManageLocations')
        },
        addRoute: function(routeType) {
            console.log('click add route');
            let newRoute = {
            	name: "New List",
                expanded: true,
            	type: routeType, /*Pickup:1 | Dropoff:2*/
            	routeDestination: {
            		// id:int,
            		// name:string,
            		// description:string
            	},
            	iteneraries:
            	[
            		// {
            		// 	id:int,
            		// 	order:int,
            		// 	stop:
            		// 	{
            		// 		id:int,
            		// 		name:string,
            		// 		description:string
            		// 	},
            		// 	schedules:
            		// 	[
            		// 		{
            		// 			id:int,
            		// 			lap:int,
            		// 			time:timeSpan,
            		// 			date: null<datetime>
            		// 		},
            		// 		{...}
            		// 	]
            		// },
            	]
            }

            this.routes.push(newRoute)

        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TopButtons.vue?69f7393c